<template>
    <VirtualAccountContainer>
        <Title>가상계좌상세</Title>

        <AccountDetailTable>
            <tbody>
                <tr>
                    <Th>등록일</Th>
                    <Td :style="{ filter: isTestUser ? 'blur(4px)' : 'none' }">{{ detail.PAYMASDT }}</Td>
                </tr>
                <tr>
                    <Th>고객명</Th>
                    <Td :style="{ filter: isTestUser ? 'blur(4px)' : 'none' }">{{ detail.CUSNM }}</Td>
                </tr>
                <tr>
                    <Th>인정번호</Th>
                    <Td :style="{ filter: isTestUser ? 'blur(4px)' : 'none' }">{{ detail.CONTENT1 }}</Td>
                </tr>
                <tr>
                    <Th>연락처</Th>
                    <Td style="display: flex; align-items: center; justify-content: center; gap: 10px;">
                        <span :style="{ filter: isTestUser ? 'blur(4px)' : 'none' }">{{ detail.MOBILENO }}</span>
                        <ResendButton @click="handleResend" type="button">
                            재발송
                        </ResendButton>
                    </Td>
                </tr>
                <tr>
                    <Th>가상계좌은행</Th>
                    <Td :style="{ filter: isTestUser ? 'blur(4px)' : 'none' }">농협</Td>
                </tr>
                <tr>
                    <Th>가상계좌번호</Th>
                    <Td :style="{ filter: isTestUser ? 'blur(4px)' : 'none' }">{{ detail.VANO }}</Td>
                </tr>
                <tr>
                    <Th>입금가능기간</Th>
                    <Td :style="{ filter: isTestUser ? 'blur(4px)' : 'none' }">{{ formatDateRange(detail.RCPSTARTDT,
                        detail.RCPENDDT) }}
                    </Td>
                </tr>
                <tr>
                    <Th>항목명</Th>
                    <Td :style="{ filter: isTestUser ? 'blur(4px)' : 'none' }">{{ detail.PAYITEMNM }}</Td>
                </tr>
                <tr>
                    <Th>입금여부</Th>
                    <Td v-html="getResultMessage(detail)" :style="{
                        backgroundColor: getStatusColor(detail),
                        fontWeight: '600',
                        filter: isTestUser ? 'blur(4px)' : 'none'
                    }">
                    </Td>
                </tr>
                <tr>
                    <Th>입금금액</Th>
                    <Td :style="{ filter: isTestUser ? 'blur(4px)' : 'none' }">{{ detail.PAYITEMAMT ?
                        Number(detail.PAYITEMAMT).toLocaleString() + '원' : ' ' }}</Td>
                </tr>
                <tr>
                    <Th>현금영수증<br />인증번호</Th>
                    <Td :style="{ filter: isTestUser ? 'blur(4px)' : 'none' }">{{ detail.RECEIPTNO }}</Td>
                </tr>
                <tr>
                    <Th>비고</Th>
                    <Td :style="{ filter: isTestUser ? 'blur(4px)' : 'none' }">{{ detail.txt }}</Td>
                </tr>
            </tbody>
        </AccountDetailTable>

        <ButtonGroup>
            <SubmitButton v-if="detail.RESULTCD === 'D000' && detail.REGDT === null" @click="handleDelete">
                삭제
            </SubmitButton>
            <CancelButton @click="closeModal">닫기</CancelButton>
        </ButtonGroup>
    </VirtualAccountContainer>
</template>

<script>
import * as AccountDetailModalCss from '@/assets/styles/account/AccountDetailModalCss.js';

const noScrollStyle = {
    overflow: 'hidden',
    paddingRight: '15px'
};

export default {
    name: 'AccountDetailModal',

    emits: ['close', 'deleted', 'success'],

    components: {
        ...AccountDetailModalCss,
    },

    props: {
        initialDetail: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            originalStyles: null, // 스크롤 방지 원래 스타일 저장
            detail: this.initialDetail,
        };
    },

    computed: {
        showDeleteButton() {
            return this.detail.RESULTCD === 'D000' && this.detail.REGDT === null;
        },
        isTestUser() {
            try {
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                return userInfo && userInfo.id === 'test';
            } catch (error) {
                return false;
            }
        }
    },

    methods: {
        closeModal() {
            this.enableScroll();
            this.$emit('close');
        },

        formatDate(dateStr) {
            if (!dateStr) return '-';
            return dateStr.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
        },

        formatDateRange(start, end) {
            if (!start || !end) return '-';
            return `${this.formatDate(start)} ~ ${this.formatDate(end)}`;
        },

        getStatusColor(item) {
            if (!item) return 'transparent';

            if (item.RESULTCD === null) {
                return '#f3f4f6'; // 등록대기 (회색)
            } else if (item.RESULTCD !== "D000") {
                return '#ef4444'; // 등록실패 (빨간색)
            } else {
                if (item.REGDT !== null) {
                    return '#b0fcb0'; // 납부 (초록색)
                } else {
                    return '#ffa19b'; // 미납 (빨간색)
                }
            }
        },

        getResultMessage(item) {
            if (!item) return '-';

            if (item.RESULTCD === null) {
                return "<span style='color: #374151'>등록대기</span>";
            } else if (item.RESULTCD !== "D000") {
                return `등록실패[${item.RESULTCD}]<br/>${item.RESULTMSG}`;
            } else {
                if (item.REGDT !== null) {
                    return `납부<br/> ${item.PAYDAY.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/g, "$1-$2-$3 $4:$5:$6")}`;
                } else {
                    return "미납";
                }
            }
        },

        // --------------------------- 가상계좌 삭제 ---------------------------
        async handleDelete() {
            if (!this.showDeleteButton) {
                await this.$swal.fire({
                    title: '삭제 불가',
                    text: '이미 납부된 데이터는 삭제할 수 없습니다.',
                    icon: 'warning'
                });
                return;
            }

            this.$swal.fire({
                title: '삭제하시겠습니까?',
                text: "삭제된 데이터는 복구할 수 없습니다.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: '삭제',
                cancelButtonText: '취소'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/virtualaccount/delete`, {
                            vkey: this.detail.REGSEQ,
                            thebill_id: this.$globalState.thebill_id,
                            company: this.$globalState.company
                        });

                        if (response.data.code === 200) {
                            await this.$swal.fire({
                                title: '삭제완료',
                                text: '삭제가 완료되었습니다.',
                                icon: 'success'
                            });

                            // 부모 컴포넌트에 성공 이벤트 전달
                            this.$emit('deleted');
                            this.$emit('success');
                            this.closeModal();
                        } else {
                            await this.$swal.fire({
                                title: '삭제실패',
                                text: response.data.message,
                                icon: 'error'
                            });
                        }
                    } catch (error) {
                        await this.$swal.fire({
                            title: '삭제실패',
                            text: error.message || '삭제 요청에 실패했습니다.',
                            icon: 'error'
                        });
                    }
                }
            });
        },
        // --------------------------- 가상계좌 재발송 ---------------------------
        async handleResend() {
            const result = await this.$swal.fire({
                title: '재발송하시겠습니까?',
                text: "가상계좌 정보를 재발송합니다.",
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#2563eb',
                cancelButtonColor: '#6b7280',
                confirmButtonText: '재발송',
                cancelButtonText: '취소'
            });

            if (result.isConfirmed) {
                try {
                    // 필수 데이터 검증
                    if (!this.detail.CUSNM) {
                        await this.$swal.fire({
                            icon: 'error',
                            title: '재발송 실패',
                            text: '고객명 정보가 없습니다.',
                            confirmButtonColor: '#2563eb'
                        });
                        return;
                    }

                    if (!this.detail.MOBILENO) {
                        await this.$swal.fire({
                            icon: 'error',
                            title: '재발송 실패',
                            text: '연락처 정보가 없습니다.',
                            confirmButtonColor: '#2563eb'
                        });
                        return;
                    }

                    if (!this.detail.VANO) {
                        await this.$swal.fire({
                            icon: 'error',
                            title: '재발송 실패',
                            text: '가상계좌번호 정보가 없습니다.',
                            confirmButtonColor: '#2563eb'
                        });
                        return;
                    }

                    if (!this.detail.PAYITEMAMT) {
                        await this.$swal.fire({
                            icon: 'error',
                            title: '재발송 실패',
                            text: '입금금액 정보가 없습니다.',
                            confirmButtonColor: '#2563eb'
                        });
                        return;
                    }

                    // API 요청 데이터 구성
                    const payload = {
                        cusnm: this.detail.CUSNM,
                        mobile: this.detail.MOBILENO,
                        vano: this.detail.VANO,
                        payamt: this.detail.PAYITEMAMT,
                        company: this.$globalState.company,
                        bank_name: this.$globalState.bank_name,
                        bank_username: this.$globalState.bank_username,
                        company: this.$globalState.company
                    };

                    // API 호출
                    const response = await this.$axios.post(
                        `${this.$apiUrls.hanqmedi}/virtualaccount/resend`,
                        payload
                    );

                    if (response.data.code === 200) {
                        await this.$swal.fire({
                            icon: 'success',
                            title: '재발송 완료',
                            text: '가상계좌 정보가 재발송되었습니다.',
                            confirmButtonColor: '#2563eb'
                        });
                    } else {
                        await this.$swal.fire({
                            icon: 'error',
                            title: '재발송 실패',
                            text: response.data.message || '재발송에 실패했습니다.',
                            confirmButtonColor: '#2563eb'
                        });
                    }
                } catch (error) {
                    console.error('가상계좌 재발송 오류:', error);
                    await this.$swal.fire({
                        icon: 'error',
                        title: '재발송 실패',
                        text: error.message || '서버 오류가 발생했습니다.',
                        confirmButtonColor: '#2563eb'
                    });
                }
            }
        },

        disableScroll() {
            this.originalStyles = {
                overflow: document.body.style.overflow || '',
                paddingRight: document.body.style.paddingRight || ''
            };
            Object.assign(document.body.style, noScrollStyle);
        },

        enableScroll() {
            if (this.originalStyles) {
                document.body.style.overflow = this.originalStyles.overflow;
                document.body.style.paddingRight = this.originalStyles.paddingRight;
                this.originalStyles = null;
            }
        }
    },

    mounted() {
        this.disableScroll();
    },

    beforeUnmount() {
        this.enableScroll();
    }
};
</script>

<style>
.blurred {
    filter: blur(4px) !important;
    pointer-events: auto;
    user-select: auto;
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
}
</style>